import { useState } from 'react';

import { executeQuery } from 'common/gql';
import { useLocalization } from 'common/providers/LocaleProvider';
import { hideAlert, showAlert } from 'common/utils/alert';
import submitReclamationMutation from '../gql/mutation/submitReclamation.gql';
import { getReclamationRequestErrorMessage } from './utils/handleErrors';

interface SubmitReclamationVariables {
  reclamationId: string;
}

type UseRequestSubmit = (
  reclamationId: string,
  successRedirectUrl: string
) => [boolean, () => void];

export const useRequestSubmit: UseRequestSubmit = (reclamationId, successRedirectUrl) => {
  const { t } = useLocalization();
  const [isLoading, setIsLoading] = useState(false);
  const submitHandler = async () => {
    setIsLoading(true);
    hideAlert();

    try {
      await executeQuery<void, SubmitReclamationVariables>({
        query: submitReclamationMutation,
        variables: {
          reclamationId,
        },
      });

      window.location.href = successRedirectUrl;
    } catch (error) {
      showAlert(t(getReclamationRequestErrorMessage(error)));
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading, submitHandler];
};
